var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "p",
        { staticClass: "title_sp" },
        [
          _c("custom-breadcrumb", { attrs: { suffix: _vm.userInfo.storeName } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "profile-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "customer-profile" }, [
            _c(
              "div",
              { staticClass: "avatar" },
              [
                _c(
                  "el-avatar",
                  { staticClass: "customer-avatar", attrs: { size: 72 } },
                  [_vm._v(_vm._s(_vm.userInfo.avatarName))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "customer-info" },
              [
                _c(
                  "el-row",
                  { staticClass: "name-row", attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.userInfo.storeName) +
                                "\n                  "
                            ),
                            _vm.userInfo["googleStoreId"] &&
                            _vm.userInfo["googleStoreId"] !== "null"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "openReport",
                                    on: {
                                      click: function($event) {
                                        return _vm.customer(_vm.userInfo)
                                      }
                                    }
                                  },
                                  [_vm._v("Open Report")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Store types")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.storeType))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Contact person")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.contactName))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Email")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "profile-value" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "email-btn",
                                attrs: { type: "info" }
                              },
                              [
                                _c("i", { staticClass: "el-icon-chat-round" }),
                                _vm._v("Send\n                  Message")
                              ]
                            ),
                            _vm._v(_vm._s(_vm.userInfo.email))
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Total Sales")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.totalSales))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Phone")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.phone))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Last transaction date")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.lastOrderTime))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Repurchase")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.repurchase))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "profile-col cust-profile-col",
                        style: {
                          paddingRight: _vm.isGoogleMap
                            ? "40px !important"
                            : "0"
                        },
                        attrs: { span: 11 }
                      },
                      [
                        _c("span", [_vm._v("Location")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "profile-value-location" }, [
                          _c("span", [_vm._v(_vm._s(_vm.userInfo.location))]),
                          _vm._v(" "),
                          _vm.isGoogleMap
                            ? _c("img", {
                                staticClass: "gmap-img",
                                attrs: {
                                  src: require("../../assets/img/gmap-icon.png")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openDialog(
                                      _vm.localStoreImgList.length - 1
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("ViLocal Order")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.vilocalCount))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 167 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "profile-col", attrs: { span: 11 } },
                      [
                        _c("span", [_vm._v("Most Recent Login")]),
                        _c("span", { staticClass: "profile-value" }, [
                          _vm._v(_vm._s(_vm.userInfo.lastLoginTime))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      this.localStoreImgList.length > 0
        ? _c(
            "div",
            { staticClass: "store-photo-container" },
            [
              _c("div", { staticClass: "title" }, [_vm._v("Store photos")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "swiper-container" },
                [
                  _c("div", {
                    staticClass:
                      "swiper-prev retailers-swiper-prev el-icon-arrow-left",
                    attrs: { slot: "button-prev" },
                    slot: "button-prev"
                  }),
                  _vm._v(" "),
                  _c(
                    "swiper",
                    {
                      ref: "swiper2",
                      staticClass: "swiper pcSwiper2",
                      staticStyle: { margin: "20px 0" },
                      style: { width: "" + _vm.width },
                      attrs: { options: _vm.localStoreSwiperOption }
                    },
                    _vm._l(_vm.localStoreImgList, function(item, key) {
                      return _c("swiper-slide", { key: key }, [
                        _c("div", { staticClass: "card-detail" }, [
                          _c("div", { staticClass: "card-img" }, [
                            _c("img", {
                              attrs: { src: item },
                              on: {
                                click: function($event) {
                                  return _vm.openDialog(key)
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "swiper-next retailers-swiper-next el-icon-arrow-right",
                    attrs: { slot: "button-next" },
                    slot: "button-next"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  staticClass: "dialog-container",
                  attrs: {
                    visible: _vm.visible,
                    width: "800px",
                    height: "600px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.visible = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "custom-close-button",
                                on: {
                                  click: function($event) {
                                    _vm.visible = false
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-close" })]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1250303646
                  )
                },
                [
                  _vm._v(" "),
                  _c(
                    "swiper",
                    {
                      ref: "dialogSwiper",
                      attrs: { options: _vm.dialogSwiperOptions }
                    },
                    _vm._l(_vm.localStoreImgList, function(item, key) {
                      return _c("swiper-slide", { key: key }, [
                        _c("div", { staticClass: "dialog-content" }, [
                          _c("img", {
                            staticClass: "dialog-slider-image",
                            attrs: { src: item }
                          })
                        ])
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dialog-navigation" }, [
                    _c("div", {
                      staticClass: "dialog-button-prev el-icon-arrow-left",
                      attrs: { slot: "button-prev" },
                      slot: "button-prev"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "dialog-button-next el-icon-arrow-right",
                      attrs: { slot: "button-next" },
                      slot: "button-next"
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "orders-samples-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "title-row" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Orders")]),
            _vm._v(" "),
            !_vm.isSelfUser
              ? _c(
                  "span",
                  {
                    staticClass: "view-btn",
                    on: {
                      click: function($event) {
                        return _vm.viewOrdersList(_vm.userInfo.userId)
                      }
                    }
                  },
                  [_vm._v("View All")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.orderTable,
                "show-empty": false,
                "empty-text": "No data found"
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "Create time" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "Order ID" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderStatus", label: "State" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("statusDis")(scope.row.orderStatus))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "totalPrice", label: "Amount" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Number(
                                scope.row.totalPrice
                              ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD"
                              })
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "shipmentDate", label: "Shipment date" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return !_vm.isSelfUser
                          ? [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.viewOrdersDetail(
                                        scope.row.orderId
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-arrow-right"
                                  })
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "orders-samples-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "title-row" }, [
            _c("span", { staticClass: "title" }, [_vm._v("ViLocal Order")]),
            _vm._v(" "),
            !_vm.isSelfUser
              ? _c(
                  "span",
                  {
                    staticClass: "view-btn",
                    on: {
                      click: function($event) {
                        return _vm.viewVilocalOrderList(_vm.userInfo.userId)
                      }
                    }
                  },
                  [_vm._v("View All")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.vilocalOrderTable,
                "show-empty": false,
                "empty-text": "No data found"
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "Create time" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "Order ID" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderStatus", label: "State" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("statusDis")(scope.row.orderStatus))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "totalPrice", label: "Amount" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Number(
                                scope.row.totalPrice
                              ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD"
                              })
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "shipmentDate", label: "Shipment date" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return !_vm.isSelfUser
                          ? [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.viewOrdersDetail(
                                        scope.row.orderId
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-arrow-right"
                                  })
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "cart-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "title-row" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Item in Cart")])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.itemCartTable,
                "max-height": "350",
                "empty-text": "No data found"
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "Create time" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goodsTitle", label: "Product name" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "vdSkuCode", label: "VD SKU" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "quantity", label: "Quantity" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "costPrice", label: "Total Amount" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Number(
                                scope.row.totalPrice
                              ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD"
                              })
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("div", { staticClass: "table-place-holder" })]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-493d324e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493d324e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customer/customersDetail.vue
// module id = 5uK+
// module chunks = 2